This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div>
    <div class="basicBlock avatarBlock">
      <p class="header upper">{{ $t("profile.avatarBlockHeader") }}</p>
      <div class="grid grid-cols-4">
        <img
          class="col-span-2 row-span-2 avatar"
          :src="preview.src"
          alt="Chosen avatar"
        />
        <img
          class="avatar"
          v-for="avatar in avatars"
          :class="[
            avatar.avatarId === preview?.avatarId ? 'selected' : 'selectable',
          ]"
          :key="avatar.avatarId"
          :src="avatar.src"
          @click="setPreview(avatar.avatarId)"
          alt="Possible avatar"
        />
      </div>
      <div class="buttonsCenter">
        <button class="button success saveButton" @click="saveAvatar(preview)">
          {{ $t("profile.avatarButton") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { getAvatar, currentAvatar, saveAvatar, avatars } from "@/utils/Avatars";

@Options({
  data() {
    return {
      avatars: avatars,
      preview: currentAvatar(),
    };
  },
  methods: {
    getAvatar,
    /**
     * Set preview avatar
     * @param avatarId Id of to be previewed avatar
     */
    setPreview(avatarId: number): void {
      this.preview = getAvatar(avatarId);
    },
    saveAvatar,
  },
})
export default class AvatarBlock extends Vue {}
</script>
